<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
<!--        <div class="note">(*) Nội dung không được bỏ trống</div>-->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          @save="saveData"
          :model="models"/>
      </div>
    </div>
  </div>
</template>

<script>
// import Config from '../../../config/index'
import DataServices from '@/core/DataServices'
import formEdit from './add'
import moment from 'moment'
import gql from "graphql-tag";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      categories: null,
      users: null,
      validationErrors: [],
      title: "Add club infomation",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      time_zone_local : moment.tz.guess(),
    }
  },
  async mounted () {
    this.mode = this.$route.name === 'editClubs' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit club infomation' : this.title;
    
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    // await this.userLogin();
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_CLUB);
    if (this.mode == 'edit'){
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0){
        this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-clubs' });
    },
    async saveData(params) {
      // console.log("params",params)
      this.images = (params.images !== undefined && params.images !== null) ? params.images : [];
      var that = this;
      // if(this.mode == 'add'){
      // var uid = this.$store.getters.user

      //   let objects = {
      //     'updated_by' : uid,
      //   }
      //   console.log("asasasasa",params)
      //   await this.$apollo.mutate({
      //     mutation: DataServices.insertData('clubs'),
      //     variables: {
      //       'objects': objects
      //     }
      //   }).then(async (res) => {
      //     if (res.data[Object.keys(res.data)].affected_rows) {
      //       var returning = res.data[Object.keys(res.data)].returning[0];
      //       // // console.log("returning",returning)
      //       for (var i = 0 ; i < params.active_distance.length ; i++) {

      //         var objects_type = {
      //           banner_id: returning.id,
      //           type: params.active_distance[i],
      //         }
      //         await this.$apollo.mutate({
      //           mutation: DataServices.insertData('banner_type'),
      //           variables: {
      //             'objects': objects_type
      //           }
      //         })
      //       }
      //       console.log("iamgeee",params.images)
      //       if (params.images.length > 0){
      //         that.$CoreService.uploadImages(that.$constants.FOLDER_S3.BANNER,params.images).then((resImage) => {
      //           // console.log("resresres:",resImage);
      //           if (resImage){
      //             var objectImage  = resImage[0];//lấy 1 tấm hình
      //             that.$CoreService.updateDataImage(that.$constants.TYPE_IMAGE.BANNER,returning.id,objectImage).then(() => {
      //               this.$commonFuction.is_loading(false);
      //               that.$toast.add({severity: 'success', summary: 'Notification', detail: 'Save success', life: 3000});
      //               this.$router.push({path: '/admin/list-banner'});
      //             });
      //           }
      //         });
      //       }
      //     }
          
      //   }).catch(async error => {
      //     console.log('error', error);
      //     that.$toast.add({
      //       severity: 'error',
      //       summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
      //       detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
      //       life: 3000
      //     });
      //     this.$commonFuction.is_loading(false);
      //   })
      // }
      // else{

        let objects = {
          // images: params.images,
          status: params.active,
          club_name: params.club_name,
          gender: params.gender,
          // ages: params.ages,
          // operating_time: params.operating_time,
          country_id: params.country_id,
          province_id: params.province,
          district_id: params.district,
          membership_fee: params.membership_fee,
          schedule: params.schedule,
          note_skill: params.note_skill,
          is_player_experience: params.is_player_experience,
          introduction: params.introduction,
          instagram: params.instagram,
          stadium_id: params.stadium_id,
          recruit_members: params.recruit_members,
          is_ban: params.is_ban ? "BANNED" : "NONE",
          skill_id: params.skill_id,
          currency_code: params.currency_code,
          // logo: params.logo,
          // logosDeletes: params.logosDeletes,
          // imagesDeletes: params.imagesDeletes,
          // experiences: params.experiences,
          updated_at : moment.tz(new Date(), this.time_zone_local)
        }
        // let variables = {
        //   'data_update': objects,
        //   'where_key': {
        //     'id': {'_eq': this.models.id}
        //   }
        // }
        // let objects_type = {
        //   'deleted':true,
        // }
        var queryUpdate = `
            mutation update_clubs_multil($clubs_object: clubs_set_input,$clubs_operating_time_objects: [clubs_operating_time_insert_input!]!,$clubs_age_objects: [clubs_age_insert_input!]!, $clubs_player_experience_objects: [clubs_player_experience_insert_input!]!) {
              update_clubs(where: { id: {_eq: "${this.models.id}"}}, _set: $clubs_object) {
                affected_rows
                returning {
                  id
                }
              }
              delete_clubs_operating_time(where: { clubs_id: {_eq: "${this.models.id}"}}) {
                returning {
                  id
                }
              }
              insert_clubs_operating_time(
                objects: $clubs_operating_time_objects
              ) {
                returning {
                  id
                }
              }
              
              delete_clubs_age(where: { clubs_id: {_eq: "${this.models.id}"}}) {
                returning {
                  id
                }
              }
              insert_clubs_age(
                objects: $clubs_age_objects
              ) {
                returning {
                  id
                }
              }
              delete_clubs_player_experience(where: { clubs_id: {_eq: "${this.models.id}"}}) {
                returning {
                  id
                }
              }
              insert_clubs_player_experience(
                objects: $clubs_player_experience_objects
              ) {
                returning {
                  id
                }
              }

            }
          `;
          var clubs_operating_time_objects = []
          for (let i = 0 ; i < params.operating_time.length ; i++) {

              clubs_operating_time_objects.push({
                clubs_id: this.models.id,
                operating_time_id: params.operating_time[i],
              })
            }
          var clubs_age_objects = []
            for (let i = 0 ; i < params.ages.length ; i++) {

              clubs_age_objects.push({
                clubs_id: this.models.id,
                ages_id: params.ages[i],
              })
            }
          var clubs_player_experience_objects = []
          for (let i = 0 ; i < params.experiences.length ; i++) {

            clubs_player_experience_objects.push({
              clubs_id: this.models.id,
              experience_id: params.experiences[i].id,
              number: params.experiences[i].number,
            })
          }
          let variables = {
            clubs_object: objects,
            clubs_operating_time_objects: clubs_operating_time_objects,
            clubs_age_objects: clubs_age_objects,
            clubs_player_experience_objects: clubs_player_experience_objects,
            // permissions_objects: dataInsertPermission
          };
          await this.$apollo.mutate({
            mutation: gql(queryUpdate),
            variables: variables
          }).then(async (res) => {
          console.log(res);
          // if (res.data[Object.keys(res.data)].affected_rows) {
              // var returning = res.data[Object.keys(res.data)].returning[0];
             // console.log(returning)
            
              //check xem tồn tại hình ảnh ko
              // if (!params.images){
              //   console.log("qwqwqwq")
              //   that.redirectEdit();
              //   return false;
              // }
              //check xem có phải hình ảnh cũ ko
            // console.log("dsdsds",params.images[0].type)
              // for (var im=0;im<params.images.length;im++){
              //   if (params.images[im].type =='old_edit'){
              //     that.redirectEdit();
              //     return false;
              //   }
              // }
              if (params.images && params.images.length > 0) {
                // for (let j=0; j < params.images.length; j++) {
                  // let image = params.images[j];
                  // let type_old =  image && Object.hasOwn(image, 'type') ? image.type : null;
                  // if (type_old != 'old_edit') {
                    //xóa hình ảnh user nếu có sự thay đổi
                    that.$CoreService.deleteDataImageMulti(that.$constants.TYPE_IMAGE.CLUB, params.imagesDeletes).then(() => {
                      that.$CoreService.uploadImages(that.$constants.FOLDER_S3.CLUBS, params.images).then((resImage) => {
                        if (resImage) {
                          for (let im=0; im < resImage.length; im++) {
                            let objectImage = resImage[im];//lấy 1 tấm hình
                            that.$CoreService.updateDataImage(that.$constants.TYPE_IMAGE.CLUB, this.models.id, objectImage).then(() => {
                              // that.redirectEdit();
                            });
                          }
                        }
                      });
                    });
                  // }
                // }
              }
              
              if (params.logo && params.logo.length > 0) {
                let type_old = params.logo[0] && Object.hasOwn(params.logo[0], 'type') ? params.logo[0].type : null;
                if (type_old != 'old_edit') {
                  //xóa hình ảnh user nếu có sự thay đổi
                  that.$CoreService.deleteDataImage(that.$constants.TYPE_IMAGE.LOGO_CLUB, this.models.id).then(() => {
                    that.$CoreService.uploadImages(that.$constants.FOLDER_S3.CLUBS, params.logo).then((resImage) => {
                      if (resImage) {
                        let objectImage = resImage[0];//lấy 1 tấm hình
                        that.$CoreService.updateDataImage(that.$constants.TYPE_IMAGE.LOGO_CLUB, this.models.id, objectImage).then(() => {
                          that.redirectEdit();
                        });
                      }
                    });
                  });
                }
              }
            // }
        }).then(() => {
          that.redirectEdit();
          // that.$commonFuction.is_loading(false);
          // that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
          // var router_back = {path: '/admin/list-record'};
          // if (!this.$commonFuction.isEmpty(router_back)){
          //   router_back.query = { page_transaction: this.page_transaction.toString() };
          // }
          // this.$router.push(router_back);
          // setTimeout(function () {
          //   this.backToList();
          // }, 1000)
        });
      // }
    },

    // updateCategory(storeID, category_id) {
    //   var isNew = (this.models.store_category == undefined  || (this.models.store_category !== undefined && this.models.store_category.length === 0)) ? true : false;
    //   if (!isNew) {
    //     let variables = {
    //       'data_update': {
    //         'category_id': category_id
    //       },
    //       'where_key': {
    //         'store_id': {'_eq': storeID}
    //       }
    //     };
    //     this.$apollo.mutate({
    //       mutation: DataServices.updateData('store_category'),
    //       variables: variables
    //     })
    //   } else {
    //     let variables = {
    //       'objects': {
    //         'category_id': category_id,
    //         'store_id': storeID
    //       }
    //     };
    //     this.$apollo.mutate({
    //       mutation: DataServices.insertData('store_category'),
    //       variables: variables
    //     })
    //   }
    // },
    // async uploadImages(storeID) {
    //   var s3client = Config.s3Client('store')
    //   if (this.images && storeID > 0) {
    //     this.$store.commit('setLoading', true);
    //     var objects = [];
    //     for (let index = 0; index < this.images.length; index++) {
    //       const img = this.images[index];
    //       let file = img
    //       if (file !== '' && img.id === undefined) {
    //         let fileName = img.name;
    //         let random = Math.random().toString().slice(2);
    //         fileName = `${random}_${fileName}`
    //         await s3client.uploadFile(file, fileName).then((data) => {
    //           objects.push({name: fileName, src: data.location, store_id: storeID, deleted: false});
    //         });
    //       }
    //     }
    //     if (objects.length > 0) {
    //       this.$apollo.mutate({
    //         mutation: DataServices.insertData('store_gallery'),
    //         variables: {
    //           objects: objects
    //         }
    //       })
    //     }
    //   }
    //   this.$toast.add({ severity: 'success', summary: 'Notification', detail: 'Save sussces', life: 3000 })
    //   this.backToList();
    // },
    async userLogin() {
      var user = this.$store.getters.user;
      var {data} = await this.$apollo.query({
        query: DataServices.getList('accounts', {"fields" : "uid"}),
        variables: {
          where_key: {
            id: {'_eq': user}
          }
        },
        fetchPolicy: "network-only"
      });
      if (data && data[Object.keys(data)] !== undefined && data[Object.keys(data)].length > 0) {
        this.accountID = data[Object.keys(data)][0].uid;
      }
    },
    async redirectEdit() {
      var that = this;
      that.$commonFuction.is_loading(false);
      var router_back = {path: '/admin/list-clubs'};
      // if (!that.$commonFuction.isEmpty(router_back)){
      //   // that.page_transaction = ""+that.page_transaction
      //   router_back.query = { page_transaction: that.page_transaction.toString() };
      // }
      that.$router.push(router_back);
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save success', life: 3000 })
    },
    async getData(id) {
      // console.log("dasdasd");
      var {data} = await this.$apollo.query({
        query: DataServices.getList('clubs', {"fields" : 'id club_name schedule gender membership_fee note_skill is_player_experience introduction instagram recruit_members status is_ban currency_code active club_operating_time{operating_time{id operating_time_lang(where: {lang: {_eq: "en"}}){name}}} clubs_player_experience{experience_id number} clubs_age{ages_id age{age_lang(where:{lang: {_eq: "en"}}){name}}} district{id district_lang(where: {lang: {_eq: "en"}}){name}} country{id country_lang(where: {lang: {_eq: "en"}}){name}} province{id province_lang(where: {lang: {_eq: "en"}}){name}} skill{id skill_lang(where: {lang: {_eq: "en"}}){name}} stadium{id name}'}),
        variables: {
          where_key: {
            id: {'_eq': id},
            // deleted: {'_eq': false}
          }
        },
        fetchPolicy: "network-only"
      })
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
        var {listData} = await this.$CoreService.getFile(this.$constants.TYPE_IMAGE.CLUB,this.models.id,0);
        if (listData.length > 0){
          this.models.images = [];
          this.models.logo = null;
          for (let i = 0; i < listData.length; i++) {
            if (listData[i]) {
              this.models.images.push(listData[i].url);
            }
          }
        }
        
        var logo = await this.$CoreService.getFile(this.$constants.TYPE_IMAGE.LOGO_CLUB,this.models.id,0);
        console.log("logologologologologologologo", logo);
        if (logo.listData.length > 0){
          this.models.logo = logo.listData[0].url;
        }
      }
      console.log("this.models",this.models)
      this.componentKey++;
    },
    async getCategories() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('category', {"fields" : "id name"}),
        fetchPolicy: "network-only"
      })
      this.categories = data[Object.keys(data)];
    }
  },
  apollo: {
    
  }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;  resize: none;}
      }
      .box-images{ margin: 0; margin-top: 10px; position: relative;
        .item-img{width: 133px; height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative;
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain; padding: 5px;}
          .button-clear{border-radius: 5px; width: 24px; height: 24px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
</style>